import React from 'react';
import {
    Box,
    TableHead,
    TableBody,
    TableCell,
    TableRow,
    Table,
    Grid,
    TableFooter,
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {
    render() {
        const generalJournal = this.props.generalJournal;
        const journalData = this.props.journalData;
        const suppliers = this.props.suppliers;
        const printDate = this.props.printDate;
        const creditSumJournalData = this.props.creditSumJournalData;
        const allJournalData = this.props.allJournalData;
        var supplierID;
        var supplierName;

        if (Array.isArray(suppliers)) {
            supplierID = generalJournal.supplierID;

            if (supplierID >= 0 && supplierID < suppliers.length) {
                supplierName = suppliers[supplierID] || "Unknown Customer";
            }
        }

        const selectedDate = this.props.selectedDate;
        const formattedDate = new Date(selectedDate).toLocaleDateString('en-GB', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
        const amount = journalData.length > 0 ? journalData[0].debit : 0;
        const numberToWords = (num) => {
            const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
            const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
            const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
            const thousands = ["", "Thousand", "Million", "Billion"];

            if (num === 0) return "Zero";
            const chunkToWords = (chunk) => {
                const chunkWords = [];

                if (chunk >= 100) {
                    chunkWords.push(ones[Math.floor(chunk / 100)]);
                    chunkWords.push("Hundred");
                    chunk %= 100;
                }

                if (chunk >= 20) {
                    chunkWords.push(tens[Math.floor(chunk / 10)]);
                    chunk %= 10;
                } else if (chunk >= 10) {
                    chunkWords.push(teens[chunk - 10]);
                    chunk = 0;
                }

                if (chunk > 0) {
                    chunkWords.push(ones[chunk]);
                }

                return chunkWords;
            };

            const words = [];
            let chunkCount = 0;

            while (num > 0) {
                const chunk = num % 1000;
                if (chunk > 0) {
                    const chunkWords = chunkToWords(chunk);
                    if (chunkCount > 0) {
                        chunkWords.push(thousands[chunkCount]);
                    }
                    words.unshift(...chunkWords);
                }
                num = Math.floor(num / 1000);
                chunkCount++;
            }
            return words.join(" ");
        };

        const totalAmount = creditSumJournalData?.[0]?.credit ?? 0;
        const formatAmountInWords = (totalAmount) => {
            const [integerPart, decimalPart] = totalAmount.toFixed(2).split('.');
            const integerInWords = numberToWords(parseInt(integerPart, 10));
            const decimalInWords = numberToWords(parseInt(decimalPart, 10));
            return `${integerInWords} Rupees and ${decimalInWords} Cents`;
        };
        const formatAmount = (amount) => {
            const [integerPart, decimalPart] = amount.toFixed(2).split('.');
            return {
                integerPart: parseInt(integerPart, 10).toLocaleString(),
                decimalPart
            };
        };
        const amountInWords = formatAmountInWords(totalAmount);
        const { integerPart: totalIntegerPart, decimalPart: totalDecimalPart } = formatAmount(creditSumJournalData?.[0]?.credit ?? 0);

        return (
            <div style={{ backgroundColor: 'white', minHeight: '100vh', border: '1px solid black', padding: '16px' }}>
                <Box minWidth={1050}>
                    <Grid style={{ display: "flex" }}>
                        <Grid style={{ flex: 1 }}>
                            <Table size="small" >
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={4} style={{ border: "1px ", fontSize: "20px", width: "25% !important" }} align="center"> <h1>{generalJournal.groupName}</h1></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan={4} style={{ border: "1px ", fontSize: "20px", width: "25% !important" }} align="center"> <h2>{creditSumJournalData?.[0]?.estateName ?? ''}</h2></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan={4} style={{ padding: "0", textAlign: "center", border: "none" }} align="center">
                                            <div style={{ border: "1px solid black", display: "inline-block", fontSize: "20px", backgroundColor: "white", color: "black", padding: "4px 8px" }}>
                                                INVOICE VOUCHER
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ border: "1px ", fontSize: "20px", width: "20% !important" }} align="right"> </TableCell>
                                        <TableCell style={{ border: "1px ", fontSize: "20px", width: "20% !important" }} align="right"> </TableCell>
                                        <TableCell style={{ border: "1px ", fontSize: "20px", width: "20% !important" }} align="left"></TableCell>
                                        <TableCell style={{ border: "1px ", fontSize: "13px", width: "40% !important" }} align="left"> <b>Voucher No &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</b> {generalJournal.referenceNumber} </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ border: "1px ", fontSize: "20px", width: "20% !important" }} align="left">  </TableCell>
                                        <TableCell style={{ border: "1px ", fontSize: "20px", width: "20% !important" }} align="right"> </TableCell>
                                        <TableCell style={{ border: "1px ", fontSize: "20px", width: "20% !important" }} align="left"></TableCell>
                                        <TableCell style={{ border: "1px ", fontSize: "13px", width: "40% !important" }} align="left"> <b>Date
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :</b> {formattedDate} </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ border: "1px ", fontSize: "20px", width: "20% !important" }} align="left">  </TableCell>
                                        <TableCell style={{ border: "1px ", fontSize: "20px", width: "20% !important" }} align="right"> </TableCell>
                                        <TableCell style={{ border: "1px ", fontSize: "20px", width: "20% !important" }} align="left"></TableCell>
                                        <TableCell style={{ border: "1px ", fontSize: "13px", width: "40% !important" }} align="left"><b> Cheque /</b><b> FT Number &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: </b> {generalJournal.modeoftransactionID == 3 ? 'Cash' : generalJournal.modeoftransactionNumber > 0 ? generalJournal.modeoftransactionNumber : '-'} </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ border: "1px ", fontSize: "20px", width: "20% !important" }} align="left">  </TableCell>
                                        <TableCell style={{ border: "1px ", fontSize: "20px", width: "20% !important" }} align="right"> </TableCell>
                                        <TableCell style={{ border: "1px ", fontSize: "20px", width: "20% !important" }} align="left"></TableCell>
                                        <TableCell
                                            style={{ border: "1px", fontSize: "13px", width: "40% !important" }}
                                            align="left"
                                        >
                                            <b> Status&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; : </b>
                                            <span style={{ backgroundColor: generalJournal.status === 1 ? "yellow" : generalJournal.status === 2 ? "#9bf09d" : generalJournal.status === 3 ? "#ff9790" : "transparent", }}>
                                                {generalJournal.status === 1 ? "Pending" : generalJournal.status === 2 ? "Approved" : generalJournal.status === 3 ? "Rejected" : "-"}
                                            </span>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={4} style={{ border: "1px ", fontSize: "20px" }} align="left"> <b>Pay to :</b> {allJournalData?.[0]?.supplierName ?? 'Unknown Supplier'}</TableCell>
                                    </TableRow>
                                    <div style={{ marginBottom: "50px" }}></div>
                                </TableBody>
                                <TableCell colSpan={4} style={{ border: "0px", padding: "0" }}>
                                    <Table style={{ borderBottom: "0px", width: "100%", maxWidth: "272mm" }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>
                                                    Account No
                                                </TableCell>
                                                <TableCell align="left" colSpan={2} style={{ fontWeight: "bold", border: "1px solid black" }}>
                                                    Ledger & Narration
                                                </TableCell>
                                                <TableCell align="right" colSpan={2} style={{ fontWeight: "bold", border: "1px solid black" }}>
                                                    Amount (LKR)
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {journalData.map((x, index) => {
                                                const amount = x.debit || x.credit;
                                                const { integerPart, decimalPart } = formatAmount(amount);
                                                return (
                                                    <TableRow key={index}>
                                                        <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>{x.ledgerAccountCode}</TableCell>
                                                        <TableCell colSpan={2} align="left" style={{ border: "1px solid black" }}>
                                                            <div>
                                                                <div style={{ fontWeight: "bold" }}>{x.ledgerAccountName}</div>
                                                                <div>{x.description == '' ? 'No description available' : x.description}</div>
                                                            </div>
                                                        </TableCell>
                                                        <TableCell align="right" style={{ fontWeight: "bold", border: "1px solid black" }}>{integerPart}</TableCell>
                                                        <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>{decimalPart}</TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell style={{ border: "1px ", fontSize: "16px" }} align="left"> <b>Amount in words : </b></TableCell>
                                                <TableCell style={{ border: "1px ", fontSize: "16px" }} align="left"> {amountInWords} only.</TableCell>
                                                <TableCell align="left" style={{ border: "1px solid black", fontWeight: "bold" }}>
                                                    Paid Amount
                                                </TableCell>
                                                <TableCell align="right" style={{ fontWeight: "bold", border: "1px solid black" }}>
                                                    {totalIntegerPart}
                                                </TableCell>
                                                <TableCell align="left" style={{ fontWeight: "bold", border: "1px solid black" }}>
                                                    {totalDecimalPart}
                                                </TableCell>
                                            </TableRow>
                                            <div>&nbsp;</div>
                                        </TableBody>
                                    </Table>
                                </TableCell>
                                <div style={{ marginBottom: "50px" }}></div>
                                <TableBody>
                                    <div>&nbsp;</div>
                                    <TableRow>
                                        <TableCell colSpan={4} style={{ border: "1px ", fontSize: "20px" }} align="left"> <b>Payee : </b>{creditSumJournalData?.[0]?.estateName ?? ''} </TableCell>
                                    </TableRow>
                                </TableBody>
                                <div style={{ marginBottom: "30%" }}></div>
                                <TableBody>
                                    <TableRow>
                                        <TableCell style={{ border: "1px ", fontSize: "15px", fontWeight: "bold", width: "25% !important" }} align="center"> Prepared by: </TableCell>
                                        <TableCell style={{ border: "1px ", fontSize: "15px", fontWeight: "bold", width: "25% !important" }} align="center"> Checked by: </TableCell>
                                        <TableCell style={{ border: "1px ", fontSize: "15px", fontWeight: "bold", width: "25% !important" }} align="center"> Approved by: </TableCell>
                                        <TableCell style={{ border: "1px ", fontSize: "15px", fontWeight: "bold", width: "25% !important" }} align="center"> Received by: </TableCell>
                                    </TableRow>
                                    <div style={{ marginBottom: "125px" }}></div>
                                    <TableRow>
                                        <TableCell style={{ border: "1px ", fontSize: "15px", fontWeight: "bold", width: "25% !important" }} align="center"> .......................................</TableCell>
                                        <TableCell style={{ border: "1px ", fontSize: "15px", fontWeight: "bold", width: "25% !important" }} align="center"> .......................................</TableCell>
                                        <TableCell style={{ border: "1px ", fontSize: "15px", fontWeight: "bold", width: "25% !important" }} align="center"> .......................................</TableCell>
                                        <TableCell style={{ border: "1px ", fontSize: "15px", fontWeight: "bold", width: "25% !important" }} align="center"> .......................................</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ border: "1px ", fontSize: "15px", fontWeight: "bold", width: "25% !important" }} align="center"> Signature & Date </TableCell>
                                        <TableCell style={{ border: "1px ", fontSize: "15px", fontWeight: "bold", width: "25% !important" }} align="center"> Signature & Date </TableCell>
                                        <TableCell style={{ border: "1px ", fontSize: "15px", fontWeight: "bold", width: "25% !important" }} align="center"> Signature & Date</TableCell>
                                        <TableCell style={{ border: "1px ", fontSize: "15px", fontWeight: "bold", width: "25% !important" }} align="center"> Signature & Date</TableCell>
                                    </TableRow>
                                </TableBody>
                                <div style={{ marginBottom: "20%" }}></div>
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={4} style={{ border: "1px ", fontSize: "20px" }}> --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------- </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan={4} style={{ border: "1px ", fontSize: "20px", width: "25% !important" }} align="center"> <u>RECEIPT</u></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan={2} style={{ border: "1px ", fontSize: "20px", width: "25% !important" }} align="left"> Received from <b>{generalJournal.groupName}</b> the sum of </TableCell>
                                        <TableCell
                                            colSpan={2}
                                            style={{ border: "1px", fontSize: "20px", width: "25% !important", fontWeight: "bold" }}
                                            align="left"
                                        >
                                            {(creditSumJournalData?.[0]?.credit ?? 0).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })}
                                        </TableCell>                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan={4} style={{ border: "1px ", fontSize: "20px", width: "25% !important" }} align="left"> {amountInWords.toUpperCase()} ONLY. </TableCell>
                                    </TableRow>
                                    <div style={{ marginBottom: "20px" }}></div>
                                    <TableRow>
                                        <TableCell colSpan={4} style={{ border: "1px ", fontSize: "20px", width: "25% !important" }} align="left"> By Cash/Cheque No ....................................... of .......................................</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan={3} style={{ border: "1px ", fontSize: "20px", width: "25% !important" }} align="left">National ID No / Date ............................................................</TableCell>
                                        <TableCell style={{ border: "1px ", fontSize: "20px", width: "25% !important" }} align="left"> Recipient</TableCell>
                                    </TableRow>
                                </TableBody>
                                <div style={{ marginBottom: "25px" }}></div>
                                <TableFooter>
                                    <TableRow>
                                        <TableCell colSpan={2} align="left" style={{ border: "1px" }}>User :  {generalJournal.preparedBy}</TableCell>
                                        <TableCell colSpan={2} align="right" style={{ border: "1px" }}>Date : {printDate}</TableCell>
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </Grid>
                    </Grid>
                </Box>
            </div>
        );
    }
}